import { useTranslation } from 'react-i18next';

import InviteInputBase from 'components/InviteInput/InviteInputBase';

import useInviteField from './useInviteField';

const InvitePeopleInput = () => {
  const { t } = useTranslation();
  const { invitees, errors, addInvitee, removeInvitee, setInvitees } = useInviteField();
  const inviteesError = errors.invitees;

  const firstErrorMessage = Array.isArray(inviteesError)
    ? inviteesError.find((error) => error && typeof error === 'object' && error.message)?.message
    : undefined;

  return (
    <div>
      <InviteInputBase
        className="min-h-[113px]"
        invitees={invitees}
        addInvitee={addInvitee}
        removeInvitee={removeInvitee}
        setInvitees={setInvitees}
        errorMessage={firstErrorMessage}
        placeholder={t('workspaces.invite_placeholder')}
        rows={invitees.length ? 1 : 3}
      />
      {!!invitees.length && <p className="text-size-sm text-gray-80 my-4">{t('workspaces.invite_placeholder')}</p>}
    </div>
  );
};

export default InvitePeopleInput;
